import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-anuncio',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './anuncio.component.html',
  styleUrl: './anuncio.component.scss'
})
export class AnuncioComponent implements OnInit, OnDestroy {
  countdown = '';
  private endDate: Date = new Date(environment.bannerEndDate);
  bannerDiscountMessage: string = environment.banner_discount_message;
  private intervalId: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.updateCountdown();
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private updateCountdown(): void {
    const now = new Date();
    const timeLeft = this.endDate.getTime() - now.getTime();

    if (timeLeft <= 0) {
      this.countdown = '';
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

    const pad = (n: number) => String(n).padStart(2, '0');
    this.countdown = `${pad(days)} DÍAS : ${pad(hours)} HRS : ${pad(minutes)} MINS`;
  }
}
